import store from '@/store';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('AccountSettingsCtrl', accountSettingsCtrl);

    function accountSettingsCtrl($scope, $rootScope, AuthService) {
        $scope.onUserUpdated = function () {
            $rootScope.user = null;
            AuthService.getSession().then(async (user) => {
                store.commit('user', user);
                $rootScope.user = user;
            });
        };
    }
})();
